import React from "react";
import {
	Utensils,
	ShoppingBag,
	Bike,
	Truck,
	Car,
	Package,
	Coffee,
	Store,
	Home,
	Bell,
	Soup,
	Salad,
	Tag,
} from "lucide-react";

/** Curated icon set offered for order types (shared keys between admin picker and cashier render). */
export const ORDER_TYPE_ICON_KEYS = [
	"utensils",
	"shopping-bag",
	"bike",
	"truck",
	"car",
	"package",
	"coffee",
	"store",
	"home",
	"bell",
	"soup",
	"salad",
] as const;

export type OrderTypeIconKey = (typeof ORDER_TYPE_ICON_KEYS)[number];

const ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
	utensils: Utensils,
	"shopping-bag": ShoppingBag,
	bike: Bike,
	truck: Truck,
	car: Car,
	package: Package,
	coffee: Coffee,
	store: Store,
	home: Home,
	bell: Bell,
	soup: Soup,
	salad: Salad,
};

export function OrderTypeIcon({ icon, className }: { icon: string | null; className?: string }) {
	const Cmp = (icon && ICONS[icon]) || Tag;
	return <Cmp className={className} />;
}

/** Preset accent colours for the swatch picker. */
export const ORDER_TYPE_COLORS = [
	"#10b981",
	"#f59e0b",
	"#3b82f6",
	"#ef4444",
	"#8b5cf6",
	"#ec4899",
	"#14b8a6",
	"#64748b",
] as const;
